// removed by extract-text-webpack-plugin
module.exports = {"card":"card-2JHXB","cardIcon":"cardIcon-25STh","cardText":"cardText-3so_h"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lists/example/assessment-card/assessment-card.less
 ** module id = 181
 ** module chunks = 0
 **/